export default "__VITE_ASSET__C1RYdL$s__"